<template>
<card title="Notifications">
    <div class="col-12 p-0">
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <checkbox :val="true" v-model="admin.newOrder" id="hasNewOrderNotification" name="hasNewOrderNotification">New Orders</checkbox>
        </div>
        <div class="col-md-5 col-lg-6 p-0" v-if="admin.newOrder">
          <div class="row m-0 align-items-end">
            <div class="col-auto pl-md-0 pr-0">
              <label for="emailNotification">Email:</label>
            </div>
            <div class="col">
              <input type="email" id="emailNotification" v-model="admin.email" class="form-control">
            </div>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
export default {
  props: ['adminDetails'],
  components: {
    Checkbox: () => import('@/components/common/Checkbox.vue'),
    Card: () => import('@/components/common/Card.vue')
  },
  data () {
    return {
      admin: {
        newOrder: false,
        email: ''
      }
    }
  },
  watch: {
    admin: {
      handler: function (val, oldVal) {
        this.$emit('update:adminDetails', this.admin)
      },
      deep: true
    }
  },
  mounted () {
    this.admin = Object.assign(this.admin, this.adminDetails)
  }
}
</script>
